<!--
@name  comTable
@author ying
@date   2022-9-1
@desc   公用table
-->

<template>
	<div class="comTable" :style="{'height':'calc('+_height+')'}" ref="comTableMain" v-loading="loading">
		<div class="comTable-table" :style="{'height':_table_height}">
			<el-table
				v-bind="$attrs" 
				:data="tableData" 
				:row-key="rowKey" 
				:key="toggleIndex" 
				ref="comTable" 
				:header-cell-style="headerCellStyle || {background:'#F2F2F2'}"
				style="width: 100%"
				:height="height=='auto'?null:'100%'" 
				:size="config.size" 
				border
				:stripe="config.stripe" 
				:summary-method="remoteSummary?remoteSummaryMethod:summaryMethod" 
				@sort-change="sortChange" 
				@filter-change="filterChange">
				<slot></slot>
				<template v-for="(item, index) in userColumn" :key="index">
					<!-- 序号列 -->
					<el-table-column
						v-if="item.type === 'index' && !item.hide"
						type="index"
						:label="item.label"
						:width="item.width || 60"
						:fixed="item.fixed"
						:index="(currentPage - 1) * comPageSize + 1">
					</el-table-column>
					<!-- 普通列 -->
					<el-table-column
							v-else-if="!item.hide"
							:min-width="120" 
							:column-key="item.prop" 
							:label="item.label" 
							:prop="item.prop" 
							:width="item.width" 
							:sortable="item.sortable" 
							:fixed="item.fixed" :filters="item.filters" 
							:filter-method="remoteFilter||!item.filters?null:filterHandler" 
							show-overflow-tooltip>
						<template #default="scope">
							<slot :name="item.prop" v-bind="scope">
								<span v-if="item.dictCode">{{ formatValueOfKey(scope.row[item.prop], item.dictCode) }}</span>
								<span v-else>{{scope.row[item.prop] || '-'}}</span>
							</slot>
						</template>
						<template #header>
							<slot :name="'header'+item.prop" v-bind="item">{{item.label}}</slot>
						</template>
					</el-table-column>
				</template>
				<!-- 有border时会有间距，无border时自适应可放开 -->
				<!-- <el-table-column min-width="1"></el-table-column> -->
				<template #empty>
					<el-empty :description="emptyText" :image-size="100"></el-empty>
				</template>
			</el-table>
		</div>
		<div class="comTable-page" v-if="!hidePagination || hideRefresh || column || hideSetting">
			<div class="comTable-pagination" v-if="!hidePagination">
				<el-pagination
					:small="true" 
					:layout="paginationLayout" 
					:total="total" 
					:page-size="comPageSize" 
					:page-sizes="pageSizes" 
					v-model:currentPage="currentPage" 
					@current-change="paginationChange" 
					@update:page-size="pageSizeChange"></el-pagination>
			</div>
			<div class="comTable-do" v-if="hideRefresh || column || hideSetting">
				<el-button v-if="hideRefresh" @click="refresh" icon="el-icon-refresh" circle style="margin-left:15px"></el-button>
				<!-- <el-popover v-if="column" placement="bottom" title="列设置" :width="500" trigger="click" :hide-after="0" @show="customColumnShow=true" @after-leave="customColumnShow=false">
					<template #reference>
						<el-button icon="el-icon-set-up" circle style="margin-left:15px"></el-button>
					</template>
					<columnSetting v-if="customColumnShow" ref="columnSetting" @userChange="columnSettingChange" @save="columnSettingSave" @back="columnSettingBack" :column="userColumn"></columnSetting>
				</el-popover> -->
				<el-popover v-if="hideSetting" placement="top" title="表格设置" :width="400" trigger="click" :hide-after="0">
					<template #reference>
						<el-button icon="el-icon-setting" circle style="margin-left:15px"></el-button>
					</template>
					<el-form label-width="80px" label-position="left">
						<el-form-item label="表格尺寸">
							<el-radio-group v-model="config.size" size="small" @change="configSizeChange">
								<el-radio-button label="large">大</el-radio-button>
								<el-radio-button label="default">正常</el-radio-button>
								<el-radio-button label="small">小</el-radio-button>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="样式">
							<el-checkbox v-model="config.border" label="纵向边框"></el-checkbox>
							<el-checkbox v-model="config.stripe" label="斑马纹"></el-checkbox>
						</el-form-item>
					</el-form>
				</el-popover>
			</div>
		</div>
	</div>
</template>

<script>
	import config from "@/config/table";
	import columnSetting from './columnSetting'
	import { mapGetters } from 'vuex'

	export default {
		name: 'comTable',
		components: {
			columnSetting
		},
		props: {
			tableName: { type: String, default: "" },
			apiObj: { type: Object, default: () => {} },
			params: { type: Object, default: () => ({}) },
			data: { type: Array, default: () => [] },
			// height: { type: [String,Number], default: "calc(100% - 37px)" },
			height: { type: [String,Number], default: "" },
			size: { type: String, default: "default" },
			border: { type: Boolean, default: false },
			stripe: { type: Boolean, default: true },
			pageSize: { type: Number, default: config.pageSize },
			pageSizes: { type: Array, default: config.pageSizes },
			rowKey: { type: String, default: "" },
			summaryMethod: { type: Function, default: null },
			column: { type: Object, default: () => {} },
			remoteSort: { type: Boolean, default: true },
			remoteFilter: { type: Boolean, default: false },
			remoteSummary: { type: Boolean, default: false },
			hidePagination: { type: Boolean, default: false },
			hideRefresh: { type: Boolean, default: false },
			hideSetting: { type: Boolean, default: false },
			paginationLayout: { type: String, default: config.paginationLayout },
			operation: {type: Boolean, default: false},
			isHasScene: {type: Boolean, default: true}, // 是否有场景，默认有
			headerCellStyle: Function,
			noRequest: {type: Boolean, default: false}, // 初始化是否请求接口，默认请求
			templateName: {type: String, default: ''}, // 页面模块名称
			queryType: {type: String, default: ''}, // 查询类型
		},
		watch: {
			//监听从props里拿到值了
			data(){
				this.tableData = this.data;
				this.total = this.tableData.length;
			},
			apiObj(){
				this.tableParams = this.params;
				this.refresh();
			}
		},
		computed: {
			_height() {
				// return Number(this.height)?Number(this.height)+'px':(this.operation ? 'calc(100% - 77px)' : this.height)
				let h = ''
				if (this.height) h = this.height
				if (this.isHasScene) h = '100% - 77px'
				if (this.height && this.operation) h = '100% - 40px'
				if (this.isHasScene && this.operation) h = '100% - 117px'
				return h
			},
			_table_height() {
				return this.hidePagination ? '100%' : 'calc(100%)'
			},
			...mapGetters(['getDictForCode']),
		},
		data() {
			return {
				comPageSize: this.pageSize,
				isActivat: true,
				emptyText: "暂无数据",
				toggleIndex: 0,
				tableData: [],
				total: 0,
				currentPage: 1,
				prop: null,
				order: null,
				descList: null, // 降序
				ascList: null, // 升序
				loading: false,
				tableHeight:'100%',
				tableParams: this.params,
				userColumn: [],
				customColumnShow: false,
				summary: {},
				config: {
					size: this.size,
					border: this.border,
					stripe: this.stripe
				}
			}
		},
		mounted() {
			//判断是否开启自定义列
			if(this.column){
				this.getCustomColumn()
			}else{
				this.userColumn = this.column
			}
			//判断是否静态数据
			if(this.apiObj){
				if (!this.noRequest) this.getData();
			}else if(this.data){
				this.tableData = this.data;
				this.total = this.tableData.length
			}
		},
		activated(){
			if(!this.isActivat){
				this.$refs.comTable.doLayout()
			}
		},
		deactivated(){
			this.isActivat = false;
		},
		methods: {
			//获取列
			async getCustomColumn(){
				const userColumn = await config.columnSettingGet(this.tableName, this.column)
				this.userColumn = userColumn
			},
			//获取数据
			async getData(){
				this.loading = true;
				let reqData = {
					pageNum: this.currentPage,
					pageSize: this.comPageSize,
					...this.tableParams
				}
				// 添加排序参数
				if(this.descList && this.descList.length > 0){
					reqData.sortField = this.descList[0]
					reqData.sortOrder = 'desc'
				} else if(this.ascList && this.ascList.length > 0){
					reqData.sortField = this.ascList[0]
					reqData.sortOrder = 'asc'
				}
				if(this.hidePagination){
					delete reqData[config.request.page]
					delete reqData[config.request.pageSize]
				}
				// Object.assign(reqData, this.tableParams)

				try {
					var res = await this.apiObj.post(reqData);
				}catch(error){
					this.loading = false;
					this.emptyText = error.statusText;
					return false;
				}
				try {
					var response = config.parseData(res);
				}catch(error){
					this.loading = false;
					this.emptyText = "数据格式错误";
					return false;
				}
				if(response.code != config.successCode){
					this.loading = false;
					this.emptyText = response.msg;
				}else{
					this.emptyText = "暂无数据";
					if(this.hidePagination){
						this.tableData = this.templateName === 'operationManagement' ? response.data[this.queryType]&&response.data[this.queryType].list || [] : response.data.list || [];
					}else{
						this.tableData = this.templateName === 'operationManagement' ? response.data[this.queryType]&&response.data[this.queryType].list || [] : response.data.list || [];
					}
					this.total = this.templateName === 'operationManagement' ? response.data[this.queryType]&&response.data[this.queryType].total || 0 : response.data.total || 0;
					this.summary = response.summary || {};
					this.loading = false;
				}
				this.$refs.comTable && this.$refs.comTable.setScrollTop(0)
				this.$emit('dataChange', res, this.tableData)
			},
			//分页点击
			paginationChange(val){
				this.currentPage = val
				this.getData();
			},
			//条数变化
			pageSizeChange(size){
				this.comPageSize = size
				this.getData();
			},
			//刷新数据
			refresh(){
				this.$refs.comTable.clearSelection();
				this.getData();
			},
			//更新数据 合并上一次params
			upData(params, page=1){
				this.currentPage = page;
				this.$refs.comTable.clearSelection();
				Object.assign(this.tableParams, params || {})
				this.getData()
			},
			//重载数据 替换params
			reload(params, page=1){
				this.currentPage = page;
				this.tableParams = params || {}
				this.$refs.comTable.clearSelection();
				this.$refs.comTable.clearSort()
				this.$refs.comTable.clearFilter()
				this.getData()
			},
			//自定义变化事件
			columnSettingChange(userColumn){
				this.userColumn = userColumn;
				this.toggleIndex += 1;
			},
			//自定义列保存
			async columnSettingSave(userColumn){
				this.$refs.columnSetting.isSave = true
				try {
					await config.columnSettingSave(this.tableName, userColumn)
				}catch(error){
					this.$message.error('保存失败')
					this.$refs.columnSetting.isSave = false
				}
				this.$message.success('保存成功')
				this.$refs.columnSetting.isSave = false
			},
			//自定义列重置
			async columnSettingBack(){
				this.$refs.columnSetting.isSave = true
				try {
					const column = await config.columnSettingReset(this.tableName, this.column)
					this.userColumn = column
					this.$refs.columnSetting.usercolumn = JSON.parse(JSON.stringify(this.userColumn||[]))
				}catch(error){
					this.$message.error('重置失败')
					this.$refs.columnSetting.isSave = false
				}
				this.$refs.columnSetting.isSave = false
			},
			//排序事件
			sortChange(obj){
				if(!this.remoteSort){
					return false
				}
				if(obj.column && obj.prop){
					this.prop = obj.prop
					this.order = obj.order
					if(obj.order === 'descending'){
						this.descList = [obj.prop]
						this.ascList = null
					} else {
						this.descList = null
						this.ascList = [obj.prop]
					}
				}else{
					this.prop = null
					this.order = null
					this.descList = null
					this.ascList = null
				}
				this.getData()
			},
			//本地过滤
			filterHandler(value, row, column){
				const property = column.property;
				return row[property] === value;
			},
			//过滤事件
			filterChange(filters){
				if(!this.remoteFilter){
					return false
				}
				Object.keys(filters).forEach(key => {
					filters[key] = filters[key].join(',')
				})
				this.upData(filters)
			},
			//远程合计行处理
			remoteSummaryMethod(param){
				const {columns} = param
				const sums = []
				columns.forEach((column, index) => {
					if(index === 0) {
						sums[index] = '合计'
						return
					}
					const values =  this.summary[column.property]
					if(values){
						sums[index] = values
					}else{
						sums[index] = ''
					}
				})
				return sums
			},
			configSizeChange(){
				this.$refs.comTable.doLayout()
			},
			//插入行 unshiftRow
			unshiftRow(row){
				this.tableData.unshift(row)
			},
			//插入行 pushRow
			pushRow(row){
				this.tableData.push(row)
			},
			//根据key覆盖数据
			updateKey(row, rowKey=this.rowKey){
				this.tableData.filter(item => item[rowKey]===row[rowKey] ).forEach(item => {
					Object.assign(item, row)
				})
			},
			//根据index覆盖数据
			updateIndex(row, index){
				Object.assign(this.tableData[index], row)
			},
			//根据index删除
			removeIndex(index){
				this.tableData.splice(index, 1)
			},
			//根据index批量删除
			removeIndexes(indexes=[]){
				indexes.forEach(index => {
					this.tableData.splice(index, 1)
				})
			},
			//根据key删除
			removeKey(key, rowKey=this.rowKey){
				this.tableData.splice(this.tableData.findIndex(item => item[rowKey]===key), 1)
			},
			//根据keys批量删除
			removeKeys(keys=[], rowKey=this.rowKey){
				keys.forEach(key => {
					this.tableData.splice(this.tableData.findIndex(item => item[rowKey]===key), 1)
				})
			},
			//原生方法转发
			clearSelection(){
				this.$refs.comTable.clearSelection()
			},
			toggleRowSelection(row, selected){
				this.$refs.comTable.toggleRowSelection(row, selected)
			},
			toggleAllSelection(){
				this.$refs.comTable.toggleAllSelection()
			},
			toggleRowExpansion(row, expanded){
				this.$refs.comTable.toggleRowExpansion(row, expanded)
			},
			setCurrentRow(row){
				this.$refs.comTable.setCurrentRow(row)
			},
			clearSort(){
				this.$refs.comTable.clearSort()
			},
			clearFilter(columnKey){
				this.$refs.comTable.clearFilter(columnKey)
			},
			doLayout(){
				this.$refs.comTable.doLayout()
			},
			sort(prop, order){
				this.$refs.comTable.sort(prop, order)
			},
			formatValueOfKey (value, resKey) {
				if (value == undefined || value == null) {
					return '-'
				}
				if (!this[`${resKey}_list`] || this[`${resKey}_list`].length === 0) {
					this[`${resKey}_list`] = this.getDictForCode(resKey)
				}
				if (this[`${resKey}_list`] && this[`${resKey}_list`].length > 0) {
					// 处理数组类型的值（多选情况）
					if (Array.isArray(value)) {
						const labels = value.map(val => {
							const res = this[`${resKey}_list`].find(item => item.dictKey == val)
							return (res && res.dictValue) || val
						}).filter(label => label !== undefined && label !== null)
						return labels.length > 0 ? labels.join(', ') : '-'
					} else {
						// 处理单个值
						const res = this[`${resKey}_list`].filter((item) => {
							return item.dictKey == value
						})[0]
						return (res && res.dictValue) || (value || '-')
					}
				} else {
					// 如果没有字典数据，直接返回原值
					if (Array.isArray(value)) {
						return value.join(', ') || '-'
					}
					return value || '-'
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	.comTable-table {height: calc(100% - 28px);}
	.comTable-page {
		display: flex;
		align-items: center;
		justify-content: space-between;
		// padding:0 15px;
		background-color: #fff;
		.comTable-pagination {
			padding: 0 10px;
			background-color: #fff;
			width: 100%;
		}
	}
	.comTable-do {white-space: nowrap;}
	.comTable:deep(.el-table__footer) .cell {font-weight: bold;}
	.comTable:deep(.el-table__body-wrapper) {
		.el-scrollbar__bar.is-horizontal {
			height: 12px;
			border-radius: 12px;
		}
		.el-scrollbar__bar.is-vertical {
			width: 12px;
			border-radius: 12px;
		}
	}
.comTable:deep {
	.el-table {
		tr {
			height: 37px;
		}
		.cell {
			font-size: 12px;
		}
		.el-table__cell{
			padding: 0;
			>.cell {
				font-size: 12px;
				padding-left: 10px;
				padding-right: 10px;
			}
		}
		th.el-table__cell {
			font-weight: bold;
			color: #333;
		}
	}
}
</style>